import { useIntl } from 'umi';
import { GithubOutlined } from '@ant-design/icons';
import { DefaultFooter } from '@ant-design/pro-layout';

export default () => {
  const intl = useIntl();
  const defaultMessage = intl.formatMessage({
    id: 'app.copyright.produced',
    defaultMessage: '蚂蚁集团体验技术部出品',
  });

  return (
    <DefaultFooter
      copyright={`2023 - 2025 南昌市索米尔家居有限公司 版权所有`}
      links={[
        {
          key: '赣ICP备2023000455号-1',
          title: '赣ICP备2023000455号-1',
          href: 'https://beian.miit.gov.cn/#/Integrated/recordQuery',
          blankTarget: true,
        },
      ]}
    />
  );
};
